import React from "react"
import Image from "components/image"

const Steps = () => {
  return (
    <div className="mb-32">
      <div className="w-11/12 xl:w-9/12 mx-auto md:px-6">
        <h2 className="text-grey-100 text-4xl  mx-auto text-center font-semibold mb-16">
          Setup Your Bank In Minutes{" "}
        </h2>
        <div className="lg:block hidden pl-10">
          <Image source="steps" />
        </div>
        <div className="lg:hidden w-11/12 md:w-7/12 mx-auto">
          <div className="mt-1 flex flex-col justify-center">
            <div className="h-20 w-20 flex items-center justify-center rounded-lg bg-blue-dark">
              <svg
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M7.5 22.5L4.5 32.25L14.25 29.25L7.5 22.5Z"
                  fill="#52BD95"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M20.25 31.5C12.3799 31.5 6 25.1201 6 17.25C6 9.37994 12.3799 3 20.25 3C28.1201 3 34.5 9.37994 34.5 17.25C34.5 25.1201 28.1201 31.5 20.25 31.5ZM12.75 19.5C13.9926 19.5 15 18.4926 15 17.25C15 16.0074 13.9926 15 12.75 15C11.5074 15 10.5 16.0074 10.5 17.25C10.5 18.4926 11.5074 19.5 12.75 19.5ZM20.25 19.5C21.4926 19.5 22.5 18.4926 22.5 17.25C22.5 16.0074 21.4926 15 20.25 15C19.0074 15 18 16.0074 18 17.25C18 18.4926 19.0074 19.5 20.25 19.5ZM27.75 19.5C28.9926 19.5 30 18.4926 30 17.25C30 16.0074 28.9926 15 27.75 15C26.5074 15 25.5 16.0074 25.5 17.25C25.5 18.4926 26.5074 19.5 27.75 19.5Z"
                  fill="white"
                />
              </svg>
            </div>
            <h6 className="mt-4 text-grey-100 font-semibold text-xl">
              Contact us
            </h6>
            <p className="text-grey-200 mt-3" style={{ lineHeight: "28px" }}>
              Select a plan and fill the form, We will reach out to you to
              provide any information you might need.
            </p>
          </div>
          <div className="mt-10 flex flex-col justify-center">
            <div className="h-20 w-20 flex items-center justify-center rounded-lg bg-blue-dark">
              <svg
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M7.5 3H28.5C30.1569 3 31.5 4.34315 31.5 6V9C31.5 10.6569 30.1569 12 28.5 12H7.5C5.84315 12 4.5 10.6569 4.5 9V6C4.5 4.34315 5.84315 3 7.5 3ZM16.5 6C15.6716 6 15 6.67157 15 7.5C15 8.32843 15.6716 9 16.5 9H24C24.8284 9 25.5 8.32843 25.5 7.5C25.5 6.67157 24.8284 6 24 6H16.5ZM10.5 9C11.3284 9 12 8.32843 12 7.5C12 6.67157 11.3284 6 10.5 6C9.67157 6 9 6.67157 9 7.5C9 8.32843 9.67157 9 10.5 9Z"
                  fill="white"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M7.5 13.5H28.5C30.1569 13.5 31.5 14.8431 31.5 16.5V19.5C31.5 21.1569 30.1569 22.5 28.5 22.5H7.5C5.84315 22.5 4.5 21.1569 4.5 19.5V16.5C4.5 14.8431 5.84315 13.5 7.5 13.5ZM16.5 16.5C15.6716 16.5 15 17.1716 15 18C15 18.8284 15.6716 19.5 16.5 19.5H24C24.8284 19.5 25.5 18.8284 25.5 18C25.5 17.1716 24.8284 16.5 24 16.5H16.5ZM10.5 19.5C11.3284 19.5 12 18.8284 12 18C12 17.1716 11.3284 16.5 10.5 16.5C9.67157 16.5 9 17.1716 9 18C9 18.8284 9.67157 19.5 10.5 19.5Z"
                  fill="#52BD95"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M7.5 24H28.5C30.1569 24 31.5 25.3431 31.5 27V30C31.5 31.6569 30.1569 33 28.5 33H7.5C5.84315 33 4.5 31.6569 4.5 30V27C4.5 25.3431 5.84315 24 7.5 24ZM16.5 27C15.6716 27 15 27.6716 15 28.5C15 29.3284 15.6716 30 16.5 30H24C24.8284 30 25.5 29.3284 25.5 28.5C25.5 27.6716 24.8284 27 24 27H16.5ZM10.5 30C11.3284 30 12 29.3284 12 28.5C12 27.6716 11.3284 27 10.5 27C9.67157 27 9 27.6716 9 28.5C9 29.3284 9.67157 30 10.5 30Z"
                  fill="#52BD95"
                />
              </svg>
            </div>
            <h6 className="mt-4 text-grey-100 font-semibold text-xl">Set-up</h6>
            <p className="text-grey-200 mt-3" style={{ lineHeight: "28px" }}>
              Your back-office application will be in production in less than
              24hrs.
            </p>
          </div>
          <div className="mt-10 flex flex-col justify-center">
            <div className="h-20 w-20 flex items-center justify-center rounded-lg bg-blue-dark">
              <svg
                width="43"
                height="36"
                viewBox="0 0 43 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M28.6054 29.4813L25.8995 26.1998C28.3366 24.1901 29.7732 21.2104 29.7732 17.9911C29.7732 14.7825 28.3461 11.8115 25.9226 9.80159L28.6378 6.52767C32.0255 9.33721 34.0265 13.503 34.0265 17.9911C34.0265 22.494 32.0123 26.6721 28.6054 29.4813ZM34.0714 36L31.355 32.7271C35.7123 29.1107 38.2798 23.7629 38.2798 17.9911C38.2798 12.2273 35.7195 6.88617 31.3725 3.2697L34.0927 0C39.4009 4.41618 42.5331 10.9502 42.5331 17.9911C42.5331 25.0418 39.3922 31.5839 34.0714 36ZM13.9277 29.4813C10.5209 26.6721 8.50662 22.494 8.50662 17.9911C8.50662 13.503 10.5076 9.33721 13.8953 6.52767L16.6105 9.80159C14.187 11.8115 12.7599 14.7825 12.7599 17.9911C12.7599 21.2104 14.1965 24.1901 16.6336 26.1998L13.9277 29.4813ZM8.46173 36C3.14091 31.5839 0 25.0418 0 17.9911C0 10.9502 3.13218 4.41618 8.44038 0L11.1606 3.2697C6.81366 6.88617 4.25331 12.2273 4.25331 17.9911C4.25331 23.7629 6.82082 29.1107 11.1781 32.7271L8.46173 36Z"
                  fill="#52BD95"
                />
                <path
                  d="M21.2665 22.2444C23.6155 22.2444 25.5198 20.3401 25.5198 17.9911C25.5198 15.6421 23.6155 13.7378 21.2665 13.7378C18.9175 13.7378 17.0132 15.6421 17.0132 17.9911C17.0132 20.3401 18.9175 22.2444 21.2665 22.2444Z"
                  fill="white"
                />
              </svg>
            </div>
            <h6 className="mt-4 text-grey-100 font-semibold text-xl">
              Launch App
            </h6>
            <p className="text-grey-200 mt-3" style={{ lineHeight: "28px" }}>
              You go live! - We also provide you with an API documentation and
              the support you.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Steps
